import React, { useEffect, useState } from 'react';
import { Formik, Form } from 'formik';
import axios from 'axios';
import { toast } from 'react-toastify';

import { getHelpCenter, updateHelpCenter } from '../../../utils/urls';
import CustomTextInput from '../../../components/common/CustomTextInput';
import CustomButton from '../../../components/common/CustomButton/CustomButton';

const HelpCenterConfig = () => {
    const [helpCenterValues, setHelpCenterValues] = useState({
        title: '',
        contact_number: '',
        description: '',
        location: '',
        email: '',
    });
    const [helpLoading, setHelpLoading] = useState(false);

    useEffect(() => {
        const fetchHelpCenterData = async () => {
            try {
                const res = await axios.get(getHelpCenter);
                const config = res?.data?.data?.config || {};
                setHelpCenterValues({
                    title: config.title || '',
                    contact_number: config.contact_number || '',
                    description: config.description || '',
                    location: config.location || '',
                    email: config.email || '',
                });
            } catch (error) {
                console.error('Failed to fetch Help Center:', error);
                toast.error('Failed to load Help Center.');
            }
        };

        fetchHelpCenterData();
    }, []);

    const handleHelpSubmit = async (values, { setSubmitting }) => {
        setHelpLoading(true);
        try {
            await axios.put(updateHelpCenter, {
                title: values.title,
                contact_number: values.contact_number,
                description: values.description,
                location: values.location,
                email: values.email,
            });
            toast.success('Help Center updated successfully!');
        } catch (error) {
            console.error('Failed to update Help Center:', error);
            toast.error('Failed to update Help Center.');
        } finally {
            setHelpLoading(false);
            setSubmitting(false);
        }
    };

    return (
        <Formik
            initialValues={helpCenterValues}
            onSubmit={handleHelpSubmit}
            enableReinitialize
        >
            <Form className="border rounded-lg p-6 shadow-sm bg-white">
                <h2 className="text-xl font-semibold text-blue-900 mb-6">Help Center</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                    <CustomTextInput name="title" label="Title" placeholder="Enter title" />
                    <CustomTextInput name="contact_number" label="Contact No" placeholder="Enter contact number" />
                    <CustomTextInput name="email" label="Email" placeholder="Enter Email" />
                    <CustomTextInput name="location" label="Location" placeholder="Enter Location" />
                </div>
                <div className="mb-6">
                    <CustomTextInput
                        name="description"
                        label="Description"
                        placeholder="Enter help center description"
                        multiline
                    />
                </div>
                <div className="flex justify-end gap-2">
                    <CustomButton label="Cancel" variant="outlined" type="button" />
                    <CustomButton
                        label="Save"
                        variant="contained"
                        type="submit"
                        className="bg-blue-500 text-white"
                        isLoading={helpLoading}
                        disabled={helpLoading}
                    />
                </div>
            </Form>
        </Formik>
    );
};

export default HelpCenterConfig;
